var getQueryParams = function getQueryParams() {
  return new URLSearchParams(window.location.search);
};
export default getQueryParams;